import { render } from "./PopMessage.vue?vue&type=template&id=44837c65&scoped=true"
import script from "./PopMessage.vue?vue&type=script&lang=js"
export * from "./PopMessage.vue?vue&type=script&lang=js"

import "./PopMessage.vue?vue&type=style&index=0&id=44837c65&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44837c65"]])

export default __exports__